module.exports = __webpack_public_path__ + "static/media/SparkasseBd.07558992.eot";